import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Login from "./Login";
import Signup from "./Signup";
import "./AuthSlider.scss";

const AuthSlider = () => {
  const { mode } = useParams();
  const navigate = useNavigate();
  const [isSignUp, setIsSignUp] = useState(mode === "signup");
  const loginPanelRef = useRef(null);
  const signupPanelRef = useRef(null);
  const [clipHeight, setClipHeight] = useState(null);

  useEffect(() => {
    setIsSignUp(mode === "signup");
  }, [mode]);

  // Size white card body to the active panel only; animate height in sync with slide (0.45s)
  useLayoutEffect(() => {
    const el = isSignUp ? signupPanelRef.current : loginPanelRef.current;
    if (!el) return;

    const apply = () => {
      setClipHeight(el.offsetHeight);
    };
    apply();

    const ro = new ResizeObserver(apply);
    ro.observe(el);
    return () => ro.disconnect();
  }, [isSignUp]);

  const handleTabChange = (newMode) => {
    setIsSignUp(newMode === "signup");
    navigate(`/auth/${newMode}`);
  };

  const bgStyle = {
    background: "linear-gradient(160deg, #0b1f1a 0%, #064e3b 40%, #047857 100%)",
  };

  const clipStyle = clipHeight != null ? { height: clipHeight } : undefined;

  return (
    <div className="auth-page" style={bgStyle}>
        <div className="auth-container">
          {/* Top toggle (let SCSS style it; no pill/shadow in JSX) */}
          <div className="auth-toggle">
            <button
              type="button"
              className={!isSignUp ? "active" : ""}
              aria-current={!isSignUp ? "page" : undefined}
              onClick={() => handleTabChange("login")}
            >
              Sign In
            </button>
            <button
              type="button"
              className={isSignUp ? "active" : ""}
              aria-current={isSignUp ? "page" : undefined}
              onClick={() => handleTabChange("signup")}
            >
              Sign Up
            </button>
          </div>

          <div className="auth-slider-clip" style={clipStyle}>
            <div className={`auth-slider ${isSignUp ? "slide-right" : "slide-left"}`}>
              <div
                ref={loginPanelRef}
                className="auth-panel w-1/2 px-5 sm:px-8 py-6 sm:py-8"
              >
                <div className="mx-auto max-w-md">
                  <Login />
                </div>
              </div>
              <div
                ref={signupPanelRef}
                className="auth-panel w-1/2 px-5 sm:px-8 py-6 sm:py-8"
              >
                <div className="mx-auto max-w-md">
                  <Signup />
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  );
};

export default AuthSlider;
